import React from 'react';
import { Grid, Typography, Container } from '@mui/material';
import ImageCard from './ImageCard';
import aiTechnologyImage from '../../assets/images/ai-technology.jpg'
import pigCountingImage from '../../assets/images/pig-counting.jpg';

const Features = () => {
  const features = [
    {
      title: 'AI-Powered Accuracy',
      description: 'Utilizes advanced AI algorithms to ensure precise pig counts.',
      image: aiTechnologyImage,
    },
    {
      title: 'Real-Time Monitoring',
      description: 'Provides instant data to help you make timely decisions.',
      image: pigCountingImage,
    },
    // Add more features as needed
  ];

  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Key Features
      </Typography>
      <Grid container spacing={4}>
        {features.map((feature, index) => (
          <Grid item xs={12} md={6} key={index}>
            <ImageCard {...feature} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Features;